import React, { useEffect, useState, useRef } from "react";
import AdminHeader from "../../layouts/admin-header";
import AdminNavBar from "../../layouts/admin-nav-bar";
import AdminFooter from "../../layouts/admin-footer";
import Loader from "../../loader";
import axios from "axios";
import { API_URL } from "../../../config/constant";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default function UtmReport({ menuAccess }) {
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [viewMode, setViewMode] = useState("table");
    const chartRef = useRef(null);

    const getUtmReportData = async () => {
        setLoader(true);
        await axios.post(API_URL + `admin/utm-summary`, {})
            .then((response) => {
                if (response.data.status === 200) {
                    setData(response.data.data.utm_summary || []);
                }
            })
            .catch(() => {});
        setLoader(false);
    };

    useEffect(() => {
        getUtmReportData();
    }, []);

    useEffect(() => {
        if (viewMode === "chart" && data.length > 0) {
            let chart = am4core.create("lineChartDiv", am4charts.XYChart);
            chart.data = data;

            let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "utm_source";

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

            let series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = "total";
            series.dataFields.categoryX = "utm_source";
            series.strokeWidth = 3;
            series.tooltipText = "{categoryX}: {valueY}";

            let bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.radius = 4;

            chart.cursor = new am4charts.XYCursor();
            chartRef.current = chart;
        }

        return () => {
            if (chartRef.current) chartRef.current.dispose();
        };
    }, [viewMode, data]);

    return (
        <>
            {loader && <Loader />}
            <div className="layout-wrapper">
                <div className="layout-container">
                    <AdminNavBar menuAccess={menuAccess} />
                    <div className="adminMain-wrapper">
                        <AdminHeader />
                        <div className="mainContent">
                            <div className="topHeadings d-flex justify-content-between align-items-center">
                                <h3>UTM Source Reports</h3>
                                <button 
                                    className="btn btn-primary"
                                    onClick={() => setViewMode(viewMode === "table" ? "chart" : "table")}
                                >
                                    Switch to {viewMode === "table" ? "Chart View" : "Table View"}
                                </button>
                            </div>

                            {viewMode === "table" && (
                                <table className="table table-bordered mt-3">
                                    <thead>
                                        <tr>
                                            <th>UTM Source</th>
                                            <th>Medium</th>
                                            <th>Leads</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length > 0 ? data.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item?.utm_source  === "null"?"-": item?.utm_source || "-"}</td>
                                                <td>{item?.source_via === "null"?"-": item?.source_via}</td>
                                                <td>{item.total || "0"}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan="3" className="text-center">No Data Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}

                            {viewMode === "chart" && (
                                <div className="mt-4">
                                    <div id="lineChartDiv" style={{ width: "100%", height: "400px" }}></div>
                                </div>
                            )}
                        </div>
                        <AdminFooter />
                    </div>
                </div>
            </div>
        </>
    );
}
